<div [ngClass]="{
    'w-100 full-height-mobile position-relative z-max': !viewportService.isLargeViewPort(),
    'h-100': viewportService.isLargeViewPort()}"
    class="d-flex flex-column w-100 overflow-y-auto overflow-x-hidden no-scroll-bar background-white z-max">
    <div [ngClass]="{'w-100': !viewportService.isLargeViewPort(), 'width-400px': viewportService.isLargeViewPort()}"
         class="flex-none row m-0 p-2 background-primary-blue height-70px w-100 shadow z-max align-items-center">
        <div class="col-2">
            <div class="d-flex justify-content-center">
                <div (click)="back()" class="pointer text-reset">
                    <i class="color-white fa-solid fa-chevron-left fa-xl"></i>
                </div>
            </div>
        </div>
        <div class="col-8 m-auto">
            <div class="text-center color-white fs-lg">Add water point</div>
        </div>
        <div class="col-2">
            <div class="d-flex justify-content-center">
                <div (click)="close()" class="pointer text-reset">
                    <i class="color-white fa-solid fa-x fa-xl"></i>
                </div>
            </div>
        </div>
    </div>
    <div class="d-flex flex-column gap-3 p-3 w-100 background-white overflow-y-auto overflow-x-hidden no-scroll-bar">
        @if (existingDeviceAssociation()) {
            <div class="card p-3">
                Device '{{ id() }}' is already associated with asset '{{ existingAsset()?.name }}'.
                Do you want to remove this association?
            </div>
            <div class="d-flex flex-column gap-2">
                <app-generic-button
                    (click)="deleteDeviceAssociation()"
                    description="Remove existing water point association"
                    [alwaysShowText]="true"
                    [buttonClass]="'btn-danger btn-danger-shadow'"
                    [buttonText]="'Remove association'"
                    [primaryIcon]="'fa-solid fa-trashcan'"/>
                <app-generic-button
                    (click)="reset()"
                    description="Cancel addition of water point"
                    [alwaysShowText]="true"
                    [buttonClass]="'btn-info'"
                    [buttonText]="'Cancel'"/>
            </div>
        } @else if (!store.deviceToMatch()) {
            <app-device-id-input
                (deviceIdSelected)="onDeviceIdSelected($event)"
                [deviceName]="'device'"
                [inputLength]="5"
                [showImage]="false" />
        } @else {
            <div class="d-flex flex-column gap-3">
                <div class="fw-bold">Associated device ID: {{ id() }}</div>
                <div class="input-group">
                    <input (input)="setName($event)"
                            [ngClass]="{'is-invalid': store.name() === undefined}"
                            [value]="store.name() || ''"
                            class="form-control m-auto"
                            placeholder="Name"
                            required
                            type="text">
                </div>
                <div class="d-flex gap-3">
                    <div class="input-group">
                        <input (input)="setLat($event)"
                                [ngClass]="{'is-invalid': store.lat() === undefined}"
                                [value]="store.lat() || ''"
                                class="form-control m-auto"
                                placeholder="Latitude"
                                required
                                type="number">
                    </div>
                    <div class="input-group">
                        <input (input)="setLong($event)"
                                [ngClass]="{'is-invalid': store.long() === undefined}"
                                [value]="store.long() || ''"
                                class="form-control m-auto"
                                placeholder="Longitude"
                                required
                                type="number">
                    </div>
                </div>
            </div>

            <app-generic-button
                (click)="onDropAPin()"
                description="Drop a pin of water point"
                [alwaysShowText]="true"
                [buttonText]="'Drop a pin'"
                [disabled]="loading()"
                [primaryIcon]="'fa-solid fa-pin'"/>

            <div class="d-flex flex-column gap-3">
                <div class="d-flex gap-3">
                    <input (input)="setNominalValue($event)"
                            [value]="store.nominalValue() || ''"
                            class="form-control m-auto"
                            placeholder="Nominal value"
                            type="number">
                    <app-info-button [message]="nominalValueInfo()"/>
                </div>
                <div class="d-flex gap-3">
                    <input (input)="setDatum($event)"
                            [value]="store.datum() || ''"
                            class="form-control m-auto"
                            placeholder="Datum"
                            type="number">
                    <app-info-button [message]="datumInfo()"/>
                </div>
                <div class="d-flex gap-3">
                    <input (input)="setHighAlertThreshold($event)"
                            [value]="store.highAlertThreshold() || ''"
                            class="form-control m-auto"
                            placeholder="High alert threshold"
                            type="number">
                    <app-info-button [message]="highAlertInfo()"/>
                </div>
                <div class="d-flex gap-3">
                    <input (input)="setHighWarningThreshold($event)"
                            [value]="store.highWarningThreshold() || ''"
                            class="form-control m-auto"
                            placeholder="High warning threshold"
                            type="number">
                    <app-info-button [message]="highWarningInfo()"/>
                </div>
                <div class="d-flex gap-3">
                    <input (input)="setLowWarningThreshold($event)"
                            [value]="store.lowWarningThreshold() || ''"
                            class="form-control m-auto"
                            placeholder="Low warning threshold"
                            type="number">
                    <app-info-button [message]="lowWarningInfo()"/>
                </div>
                <div class="d-flex gap-3">
                    <input (input)="setLowAlertThreshold($event)"
                            [value]="store.lowAlertThreshold() || ''"
                            class="form-control m-auto"
                            placeholder="Low alert threshold"
                            type="number">
                    <app-info-button [message]="lowAlertInfo()"/>
                </div>
            </div>

            <app-generic-button
                (click)="processNewAsset()"
                description="Add water point"
                [alwaysShowText]="true"
                [buttonText]="'Add'"
                [disabled]="!canProcessNewAsset()"
                [loading]="loading()"
                [primaryIcon]="'fa-solid fa-check'"/>

            <app-generic-button
                (click)="reset()"
                description="Cancel adding new water point"
                [alwaysShowText]="true"
                [buttonClass]="'btn-info'"
                [buttonText]="'Cancel'"/>
        }
    </div>
</div>
